import { render, staticRenderFns } from "./BurpButton.vue?vue&type=template&id=2c853ad8&lang=pug"
import script from "./BurpButton.vue?vue&type=script&lang=js"
export * from "./BurpButton.vue?vue&type=script&lang=js"
import style0 from "./BurpButton.vue?vue&type=style&index=0&id=2c853ad8&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports